import React from "react";
import Button from "@mui/material/Button";
import { useFieldArray } from "react-hook-form";
// eslint-disable-next-line import/no-cycle
import PTMAppBar from "./PTMAppBar";
// eslint-disable-next-line import/no-cycle
import PTMDialog from "./PTMDialog";
import PTMInput from "./PTMInput";
// eslint-disable-next-line import/no-cycle
import PTMIcon from "./PTMIcon";
import PTMInputContainer from "./PTMInputContainer";

function Selectable(props) {
    const {
        item, addItem, removeItem, formatItem,
    } = props;

    const [selected, setSelected] = React.useState(false);

    const selectItem = (isSelected) => {
        setSelected(!selected);
        if (isSelected) {
            removeItem(item);
        } else {
            addItem(item);
        }
    };

    const input = (
        <PTMInput
            disabled
            value={formatItem(item)}
            endAdornment={(
                <Button
                    color={!selected ? "success" : "error"}
                    variant="contained"
                    sx={{ height: "100%" }}
                    onClick={() => selectItem(selected)}
                >
                    <PTMIcon
                        icon={!selected ? "plus" : "times"}
                        popover={!selected ? "hinzufügen" : "entfernen"}
                    />
                </Button>
            )}
        />
    );

    return (
        input
    );
}

function SelectionDialog(props) {
    const {
        isOpen,
        tabId,
        closeDialog,
        append,
        list,
        title,
        formatItem,
        dialogStyle,
    } = props;

    const [selectedRoles, setSelectedRoles] = React.useState([]);
    const [searchString, setSearchString] = React.useState("");

    const addItem = (role) => {
        const newRoles = [...selectedRoles];
        newRoles.push({ ...role, tmpId: true });
        setSelectedRoles(newRoles);
    };
    const removeItem = (selectedRole) => {
        const newRoles = [...selectedRoles].filter((role) => role !== selectedRole);
        setSelectedRoles(newRoles);
    };

    const selectRoles = () => {
        append(selectedRoles);
        setSelectedRoles([]);
        closeDialog();
    };

    return (
        <PTMDialog
            title={`${title}auswahl`}
            fixedWidth={dialogStyle?.width}
            tabId={tabId}
            containerId={`tab-${tabId}-container`}
            open={isOpen}
            onClose={closeDialog}
            footerButtons={[
                {
                    name: "Übernehmen",
                    color: "success",
                    icon: "save",
                    disabled: selectedRoles.length === 0,
                    click: selectRoles,
                },
                {
                    name: "Abbrechen",
                    color: "error",
                    icon: "times",
                    click: closeDialog,
                },
            ]}
        >
            <PTMInputContainer
                inputs={[
                    {
                        input: (
                            <PTMInput
                                placeholder="Suchen..."
                                noForm
                                value={searchString}
                                onChange={(e) => setSearchString(e.target.value.toLowerCase())}
                            />),
                    }]}
                containerSx={
                    {
                        "&>.MuiGrid-root": {
                            marginBottom: 2,
                        },
                    }
                }

            />
            <PTMInputContainer
                containerSx={
                    {
                        "&>.MuiGrid-root": {
                            marginBottom: "4px",
                        },
                    }
                }
                inputs={list.filter((item) => formatItem(item).toLowerCase().includes(searchString)).map((item) => (
                    {
                        input: (<Selectable
                            key={item.id}
                            item={item}
                            addItem={addItem}
                            removeItem={removeItem}
                            formatItem={formatItem}
                        />),
                    }
                ))}
            />
        </PTMDialog>
    );
}

function Item(props) {
    const {
        item,
        remove,
        i,
        type,
        formatItem,
    } = props;

    return (
        <PTMInput
            disabled
            value={formatItem(item)}
            {...type !== "view" && {
                endAdornment: (
                    <Button
                        color="error"
                        variant="contained"
                        sx={{ height: "100%" }}
                        onClick={() => remove(i)}
                    >
                        <PTMIcon
                            icon="times"
                            popover="entfernen"
                        />
                    </Button>
                ),
            }}
        />
    );
}

export default function PTMList(props) {
    const {
        tabId,
        control,
        type,
        title,
        icon,
        getList,
        formatItem,
        fieldArrayName,
        selectDialogStyle,
    } = props;

    const [dialogIsOpen, setDialogIsOpen] = React.useState(false);
    const [list, setList] = React.useState([]);

    React.useEffect(() => {
        const controller = new AbortController();
        (async () => {
            const data = await getList(controller);
            setList(data);
        })();
        return () => {
            controller.abort();
        };
    }, []);

    const {
        fields,
        append,
        remove,
    } = useFieldArray(
        {
            control,
            keyName: "validationId",
            name: fieldArrayName,
        },
    );

    return (
        <>
            <PTMAppBar
                icon={icon}
                title={title}
                {...type !== "view" && {
                    controlButtons: [
                        {
                            icon: "plus",
                            color: "success",
                            title: "Hinzufügen",
                            displayTitle: true,
                            click: () => setDialogIsOpen(true),
                        }],
                }}
            />
            <SelectionDialog
                isOpen={dialogIsOpen}
                closeDialog={() => setDialogIsOpen(false)}
                append={append}
                list={list.filter((item) => !fields.some((filterItem) => item.id === filterItem.id))}
                tabId={tabId}
                title={title}
                formatItem={formatItem}
                dialogStyle={selectDialogStyle}
            />
            <PTMInputContainer
                containerSx={
                    {
                        marginTop: "10px",
                        "&>.MuiGrid-root": {
                            marginBottom: "4px",
                        },
                    }
                }
                inputs={
                    (fields.map((item, i) => ({
                        input: (
                            <Item
                                item={item}
                                remove={remove}
                                i={i}
                                type={type}
                                formatItem={formatItem}
                            />
                        ),
                    })))
                }
            />
        </>
    );
}
